module.exports = {
  footerText: 'Koletra © 2025',
}
